import { WSQueryConfig } from "@ws-react-query";
import { getWorkLogConfigForPayee } from "../../../services/workLogConfig";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { QUERY_WORK_LOG_CONFIG_FOR_PAYEE } from "../keys";

export const useQueryWorkLogConfigForPayee = (
  payerId: string,
  config?: WSQueryConfig<
    Awaited<ReturnType<typeof getWorkLogConfigForPayee>>,
    WSServiceError
  >
) =>
  useWSQuery(
    [QUERY_WORK_LOG_CONFIG_FOR_PAYEE, payerId],
    () => getWorkLogConfigForPayee(payerId),
    config
  );
